<template>
	<footer class="footer">
		<transition name="slide-down">
			<HYButton
				v-if="isLive && selectedVoice"
				class="footer__cta-button"
				variant="primary"
				fitContent
				iconPosition="left"
				size="xl"
				@click="handleClickApplyVoice"
			>
				<span class="footer__cta-button-text">
					{{ t('footer.applyVoiceFilter.text') }}
				</span>
				<img
					src="../assets/mic.svg"
					alt="Apply Voice Filter"
					class="footer__apply-voice-icon"
				/>
			</HYButton>
		</transition>

		<span class="footer__legend interactive-sm">
			{{ t('footer.title') }}

			<br />

			<HYLink
				:to="getDownloadLink()"
				variant="primary"
				target="_blank"
			>
				{{ t('footer.downloadLink.text') }}
			</HYLink>
		</span>
	</footer>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

import { HYButton, HYLink } from '@voicemod1/harmony-ui';

import { useApplyVoice } from '../composables/useApplyVoice';
import { useStore } from '../store';
import { getDownloadLink } from '../utils/getDownloadLink';

const { t } = useI18n();
const store = useStore();
const { isLive, selectedVoice } = storeToRefs(store);

const { handleClickApplyVoice } = useApplyVoice();
</script>

<style lang="scss" scoped>
.footer {
	pointer-events: none;

	display: flex;
	flex-direction: column;
	gap: var(--hy-space-sm);
	align-items: center;
	justify-content: flex-end;

	max-height: 200px;
	padding: var(--hy-space-md) 0;

	background: linear-gradient(
		0deg,
		rgb(4 6 6 / 80%) 0%,
		rgb(4 6 6 / 50%) 70%,
		rgb(4 6 6 / 0%) 100%
	);

	transition: all 0.5s ease;

	&__legend {
		font-weight: var(--hy-font-weight-normal);
		line-height: var(--hy-font-line-height-xl);
		color: var(--hy-color-text-default);
		text-align: center;

		:deep(.hy-link) {
			pointer-events: auto;
		}
	}

	&__cta-button {
		pointer-events: auto;
		max-width: calc(100% - var(--hy-space-xl));
	}

	&__cta-button-text {
		overflow: hidden;
		width: 100%;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.slide-down-enter-active,
	.slide-down-leave-active {
		transition: all 0.1s ease;
	}

	.slide-down-enter-from,
	.slide-down-leave-to {
		transform: translateY(100%);
		opacity: 0;
	}
}
</style>
